import React from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { formatCurrency } from "../utils/adminDashboardUtils";

const COLORS = ["#2563EB", "#38BDF8", "#4F46E5", "#22C55E", "#F59E0B"];

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;

  const item = payload[0]?.payload;

  return (
    <div className="rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm shadow-xl dark:border-white/10 dark:bg-slate-900">
      <p className="font-bold text-slate-950 dark:text-white">{item.name}</p>
      <p className="text-slate-500 dark:text-white/60">
        Montant :{" "}
        <span className="font-bold text-slate-950 dark:text-white">
          {formatCurrency(item.value)}
        </span>
      </p>
    </div>
  );
}

function SubscriptionBreakdownCard({ data = [] }) {
  const hasData = data.length > 0;

  return (
    <article className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-xl shadow-slate-200/60 dark:border-white/10 dark:bg-slate-900 dark:shadow-black/20">
      <div>
        <p className="text-xs font-bold uppercase tracking-[0.14em] text-sky-700 dark:text-sky-200">
          Revenus
        </p>

        <h2 className="mt-2 font-titre text-2xl font-bold text-slate-950 dark:text-white">
          Répartition abonnements
        </h2>
      </div>

      <div className="mt-5 h-[360px]">
        {hasData ? (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} margin={{ top: 10, right: 10, left: -15, bottom: 0 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} opacity={0.22} />
              <XAxis
                dataKey="name"
                tick={{ fontSize: 12, fontWeight: 700 }}
                axisLine={false}
                tickLine={false}
              />
              <YAxis
                tick={{ fontSize: 12, fontWeight: 700 }}
                axisLine={false}
                tickLine={false}
              />
              <Tooltip content={<CustomTooltip />} />

              <Bar dataKey="value" radius={[14, 14, 6, 6]} barSize={46}>
                {data.map((entry, index) => (
                  <Cell key={entry.name} fill={COLORS[index % COLORS.length]} />
                ))}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <div className="flex h-full items-center justify-center rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 text-sm font-bold text-slate-400 dark:border-white/10 dark:bg-white/[0.03]">
            Aucun détail d’abonnement disponible.
          </div>
        )}
      </div>
    </article>
  );
}

export default SubscriptionBreakdownCard;